import { memo, useCallback } from 'react';
import { CardData } from '../../../../../types';
import { InputField } from './InputField';
import { CheckboxField } from './CheckboxField';

interface ContentInputsProps {
    cardNum: 1 | 2;
    data: CardData;
    disabled: boolean;
    onChange: (cardNum: 1 | 2, field: keyof CardData, value: any) => void;
}

export const ContentInputs = memo(({
    cardNum,
    data,
    disabled,
    onChange,
}: ContentInputsProps) => {

    const handleArrowChange = useCallback((e: React.ChangeEvent<HTMLInputElement>) => {
        onChange(cardNum, 'showArrow', e.target.checked);
    }, [onChange, cardNum]);


    return (
        <div className="content-section">
            <InputField
                cardNum={cardNum}
                idSuffix="title"
                label="Title"
                field="title"
                value={data.title}
                placeholder="Enter the card title here."
                disabled={disabled}
                onChange={onChange}
            />
            <InputField
                cardNum={cardNum}
                idSuffix="subtitle"
                label="Subtitle (Optional)"
                field="subtitle"
                value={data.subtitle}
                placeholder="Enter the card subtitle here."
                disabled={disabled}
                onChange={onChange}
            />

            <div className="input-pair-row">
                <InputField
                    cardNum={cardNum}
                    idSuffix="btnText"
                    label="Button Text"
                    field="btnText"
                    value={data.btnText}
                    placeholder="Enter the button text here."
                    disabled={disabled}
                    onChange={onChange}
                />
                <CheckboxField
                    id={`arrow-${cardNum}`}
                    label="Arrow"
                    checked={data.showArrow !== false}
                    onChange={handleArrowChange}
                    disabled={disabled}
                />
            </div>


        </div>
    );
});
